import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { ConsumoUnidadeMedidaEnum } from "features/consumo/typings";

export interface SelectUnidadeMedidaConsumoProps<T = any>
  extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  filteredOptions?: ConsumoUnidadeMedidaEnum[];
}

function SelectUnidadeMedidaConsumo({
  value,
  filteredOptions,
  ...rest
}: SelectUnidadeMedidaConsumoProps) {
  const options = [
    {
      label: "Quilogramas",
      value: ConsumoUnidadeMedidaEnum.Kilos,
    },
    {
      label: "Litros",
      value: ConsumoUnidadeMedidaEnum.Litros,
    },
    {
      label: "Metros cúbicos",
      value: ConsumoUnidadeMedidaEnum.MetrosCubicos,
    },
    {
      label: "Killowatt-Hora",
      value: ConsumoUnidadeMedidaEnum.KilowattHora,
    },
  ].filter((o) =>
    filteredOptions ? !filteredOptions.includes(o.value) : true
  );

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      defaultValue={null}
      options={options}
      {...rest}
    />
  );
}

export default SelectUnidadeMedidaConsumo;
